import { render, staticRenderFns } from "./academicDetail.vue?vue&type=template&id=d752225e&scoped=true"
import script from "./academicDetail.vue?vue&type=script&lang=js"
export * from "./academicDetail.vue?vue&type=script&lang=js"
import style0 from "./academicDetail.vue?vue&type=style&index=0&id=d752225e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d752225e",
  null
  
)

export default component.exports